import { CustomData, lazyLogDatapoint } from 'owa-analytics';
import UsageDatapoint from 'owa-analytics/lib/datapoints/UsageDatapoint';

export default function logUnsampledDatapoint(
    datapointName: string,
    customData: CustomData,
    cosmosOnlyData?: string
): void {
    const datapoint = new UsageDatapoint(datapointName, customData, {
        isCore: true,
        isCosmosDatapoint: true,
    });

    if (cosmosOnlyData) {
        datapoint.addCosmosOnlyData(cosmosOnlyData);
    }

    lazyLogDatapoint.importAndExecute(datapoint);
}
